module.exports = __webpack_public_path__ + "img/estatusDeclinado.75060f4d.png";